import React, { useEffect, useRef } from 'react'
import S from './ProgressCircle.styles'

interface ProgressCircleProps {
  radius: number
  strokeWidth: number
  progress: number
  text?: string
}

const ProgressCircle: React.FC<ProgressCircleProps> = ({ radius, strokeWidth, progress, text }) => {
  const circumference = 2 * Math.PI * radius
  const progressRef = useRef<SVGCircleElement | null>(null)

  useEffect(() => {
    const progressOffset = ((100 - progress) / 100) * circumference
    if (progressRef.current) {
      progressRef.current.style.strokeDashoffset = `${progressOffset}`
    }
  }, [circumference, progress])

  return (
    <S.Wrapper>
      <svg width={radius * 2} height={radius * 2} viewBox={`0 0 ${radius * 2} ${radius * 2}`}>
        {/* Track */}
        <circle
          cx={radius}
          cy={radius}
          r={radius - strokeWidth / 2}
          strokeWidth={strokeWidth}
          fill="transparent"
          stroke="#000000"
        />
        {/* Progress */}
        <circle
          ref={progressRef}
          cx={radius}
          cy={radius}
          r={radius - strokeWidth / 2}
          strokeWidth={strokeWidth}
          fill="transparent"
          stroke="#89B641"
          strokeLinecap="round"
          strokeDasharray={circumference}
          transform={`rotate(-90, ${radius}, ${radius})`}
        />
      </svg>
      {text && <S.Text>{text}</S.Text>}
    </S.Wrapper>
  )
}

export default ProgressCircle
